import { LocaleService } from '@sm360/widget-commons-core-services';
import { InputCheckbox } from '@sm360/widget-commons-forms';
import 'inventory-listing/components/ListingFilters/Components/ListingFiltersDriveTrain/DriveTrain.scss';
import MetaDataModel from 'inventory-listing/models/MetaDataModel.js';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

const DriveTrain = ({ driveTrain, handleChange }) => {
    const label = isEmpty(driveTrain?.label) ? LocaleService.t('UNKNOWN') : driveTrain.label;
    const fullLabel = driveTrain.count > 0 ? `${label} (${driveTrain.count})` : label;

    return (
        <li className="listing-used-drivetrain">
            <InputCheckbox
                label={fullLabel}
                value={driveTrain.code.toString()}
                valueChange={() => handleChange(driveTrain.code)}
                isSelected={driveTrain.isSelected}
            />
        </li>
    );
};

DriveTrain.propTypes = {
    driveTrain: PropTypes.instanceOf(MetaDataModel).isRequired,
    handleChange: PropTypes.func.isRequired,
};

DriveTrain.displayName = 'DriveTrain';

export default DriveTrain;
